import { html, LitElement } from 'lit-element';
import { createCorrectnessText, getPercentage, latexToHTML } from './utils.js';

/**
 * @element header-block-ecr
 * @prop {Object} item - Item
 * @prop {Object} session - session
 * @prop {Object} studentsNumber - students Number
 * @prop {Number} studentsAnsweredNr - The number of all the student that answered the question
 */
export class HeaderBlockECR extends LitElement {
  static get properties() {
    return {
      item: { type: Object, attribute: false },
      studentsNumber: { type: Number, attribute: false },
      studentsAnsweredNr: { type: Number, attribute: false },
      session: { type: Number, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  _openRationale() {
    const { rationale } = this.item || {};

    const content = html`<rationale-modal
      .rationale=${rationale}
    ></rationale-modal>`;

    window.dispatchEvent(
      new CustomEvent('classroom-tool-live-open-modal', {
        detail: {
          modalContent: content,
          modalType: 'rationale-modal',
        },
      })
    );
  }

  _openDetails() {
    const studentsNr = this.studentsNumber || 0;
    const studentsAnsweredNr = this.studentsAnsweredNr || 1;

    const content = html`<view-details-modal-ecr
      .response=${{
        item: this.item,
        studentsNr,
        studentsAnsweredNr,
      }}
    ></view-details-modal-ecr>`;

    window.dispatchEvent(
      new CustomEvent('classroom-tool-live-open-modal', {
        detail: {
          modalContent: content,
          modalType: 'view-details-modal-ecr',
          modalTitle: html`<p><strong>Details</strong></p>`,
        },
      })
    );
  }

  render() {
    const studentsNr = this.studentsNumber || 0;
    const percentage = getPercentage(
      this.studentsNumber,
      this.studentsAnsweredNr
    );

    const { autoScore, manualScore, correctnessGroup } = this.session || {};
    const { choices } = this.item || {};

    const { points } = autoScore || manualScore || {};
    const correctness = correctnessGroup || 'unanswered';
    const correctnessText = createCorrectnessText(points);
    const correctAnswer =
      choices &&
      Object.keys(choices)
        .map(key => choices[key] && choices[key][0] && choices[key][0].label)
        .join(', ');

    return html` <div class="header-block">
      <div class="block">
        <div class="header-correct-response">
          <div class="header-correct-response-selection ${correctness}">
            ${correctnessText}
          </div>
          ${correctness === 'correct'
            ? html`<div
                class="header-correct-response-value header-correct-response-value-math"
              >
                <math-rendering-element
                  .label="${latexToHTML(correctAnswer)}"
                ></math-rendering-element>
                <div class="header-correct-response-value-overflow"></div>
                <div
                  class="header-correct-response-value-bottom-overflow"
                ></div>
              </div>`
            : null}
        </div>

        <div class="more">
          ${correctness === 'correct'
            ? html`<button class="more-button" @click=${this._openDetails}>
                  <span>View Details</span>
                </button>
                <button class="more-button" @click=${this._openRationale}>
                  <span>Rationale</span>
                </button>`
            : null}
        </div>
      </div>

      <div class="block header-students-number">
        ${studentsNr} Student${studentsNr === 1 ? '' : 's'} (${percentage}%)
      </div>
    </div>`;
  }
}

export default HeaderBlockECR;
